export default "__VITE_ASSET__DYDDb4$x__"